module.exports = __webpack_public_path__ + "static/media/trashIcon.bf874dc4.svg";